import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'
import cashBreakSettingsReducer from './cash-break/cash-break.reducer'
import commandsReducer from './commands/commands.reducer'
import { ErrorLogEffects } from './error-log/error-log.effects'
import errorLogReducer from './error-log/error-log.reducer'
import filtersReducer from './filters/filters.reducer'
import focusedReducer from './focused/focused.reducer'
import { reducers } from './helios'
import { CommentaryActivityEffects } from './helios/commentary-activity/commentary-activity.effects'
import { CommentaryCountsEffects } from './helios/commentary-counts/commentary-counts.effects'
import { SessionEffects } from './helios/session/session.effects'
import { panelReducers } from './panels'
import persistentReducer from './persistent-state'
import reportingReducer from './reporting/reporting.reducer'

@NgModule({
  imports: [
    CommonModule,
    // NOTE — do NOT import HttpClientModule here. Effects in this module
    // (SessionEffects, ErrorLogEffects, CommentaryCountsEffects,
    // CommentaryActivityEffects) take HttpClient by constructor injection and
    // MUST resolve it from the AppModule root injector so they get the OIDC
    // auth interceptor chain. Importing HttpClientModule here creates a
    // second `HttpClient` provider in this feature module's injector — Angular
    // hierarchical DI then resolves the local one first, and effects fire HTTP
    // requests **without the bearer**. That breaks every helios-* call dispatched
    // from this module's effects (commands, restricted-request-ids, session
    // users/auxiliary, accounts-list, ...), leaving NgRx slices in "loading
    // forever" state — symptom: the accounts grid never renders its
    // <ag-grid-angular> because session never reaches "active" so
    // `createGridOptions()` never resolves.
    // For unit tests of effects in this module, the test bed should import
    // `HttpClientTestingModule` directly — that's the standard pattern.
    StoreModule.forFeature('helios', reducers),
    StoreModule.forFeature('panels', panelReducers),
    StoreModule.forFeature('filters', filtersReducer),
    StoreModule.forFeature('focused', focusedReducer),
    StoreModule.forFeature('commands', commandsReducer),
    StoreModule.forFeature('errorLog', errorLogReducer),
    StoreModule.forFeature('persistent', persistentReducer),
    StoreModule.forFeature('cashBreakSettings', cashBreakSettingsReducer),
    StoreModule.forFeature('reporting', reportingReducer),
    EffectsModule.forRoot([]),
    EffectsModule.forFeature([
      ErrorLogEffects,
      SessionEffects,
      CommentaryCountsEffects,
      CommentaryActivityEffects,
    ]),
  ],
})
export class StateManagementModule {}
